import { Toast, Indicator, MessageBox } from 'mint-ui'
import { GetSAppInfo } from '@/api/my'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      infoData: {}
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['SET_S_APP_INFO']),
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      GetSAppInfo()
        .then((res) => {
          this.infoData = res
          this.SET_S_APP_INFO(res)
          Indicator.close()
        })
        .catch((res) => {
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
          Indicator.close()
        })
    },
    // 修改淘宝号
    editPlatformNumber() {
      MessageBox({
        title: '提示',
        message: '暂时不支持修改淘宝号',
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      })
    },
    // 修改手机号
    editPhone() {
      MessageBox({
        title: '提示',
        message: '暂时不支持修改手机号',
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      })
    },
    // 关于我们
    aboutUs() {
      this.$router.push('aboutUs')
    }
  }
}
